import type { Static } from 'runtypes';
import { Literal, Record, String } from 'runtypes';
import { CoreEventRuntype } from './core';
import type { BaseEvent } from './base';
import { BaseEventRuntype } from './base';
import { ClickstreamEventEnum } from 'bc-model';

const PageViewedEventBrowserRuntype = BaseEventRuntype.And(
  Record({
    event: Literal(ClickstreamEventEnum.PAGE_VIEWED),
    path: String,
    referrer: String,
    search: String,
    title: String,
    url: String,
    version: Literal(2),
  })
);

const PageViewedEventServerRuntype = PageViewedEventBrowserRuntype.And(CoreEventRuntype).And(
  Record({
    sessionId: String,
  })
);

type PageViewedBrowserEvent = Static<typeof PageViewedEventBrowserRuntype>;
type PageViewedServerEvent = Static<typeof PageViewedEventServerRuntype>;

const isPageViewedBrowserEvent = (obj: BaseEvent): obj is PageViewedBrowserEvent => {
  return obj.event === 'Page Viewed';
};

const isPageViewedServerEvent = (obj: BaseEvent): obj is PageViewedServerEvent => {
  return obj.event === 'Page Viewed';
};

export {
  isPageViewedBrowserEvent,
  isPageViewedServerEvent,
  PageViewedEventBrowserRuntype,
  PageViewedEventServerRuntype,
  type PageViewedBrowserEvent,
  type PageViewedServerEvent,
};
